var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) translate(0.375000, 0.375000)",
    fill: "#212529",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.828125,3.421875 C22.109375,5.671875 23.25,8.40625 23.25,11.625 C23.25,14.84375 22.1171875,17.5859375 19.8515625,19.8515625 C17.5859375,22.1171875 14.84375,23.25 11.625,23.25 C8.40625,23.25 5.6640625,22.1171875 3.3984375,19.8515625 C1.1328125,17.5859375 0,14.84375 0,11.625 C0,8.40625 1.1328125,5.6640625 3.3984375,3.3984375 C5.6640625,1.1328125 8.40625,0 11.625,0 C14.84375,0 17.578125,1.140625 19.828125,3.421875 Z M11.625,21.75 C14.4375,21.75 16.828125,20.7578125 18.796875,18.7734375 C20.765625,16.7890625 21.75,14.40625 21.75,11.625 C21.75,8.8125 20.7578125,6.421875 18.7734375,4.453125 C16.7890625,2.484375 14.40625,1.5 11.625,1.5 C8.8125,1.5 6.421875,2.4921875 4.453125,4.4765625 C2.484375,6.4609375 1.5,8.84375 1.5,11.625 C1.5,14.4375 2.4921875,16.828125 4.4765625,18.796875 C6.4609375,20.765625 8.84375,21.75 11.625,21.75 Z M11.0625,17.4375 L5.625,12 C5.375,11.75 5.375,11.5 5.625,11.25 L11.0625,5.8125 C11.3125,5.5625 11.5625,5.5625 11.8125,5.8125 L12.140625,6.140625 C12.421875,6.421875 12.421875,6.6875 12.140625,6.9375 L8.15625,10.828125 L17.0625,10.828125 C17.4375,10.828125 17.625,11.015625 17.625,11.390625 L17.625,11.859375 C17.625,12.234375 17.4375,12.421875 17.0625,12.421875 L8.15625,12.421875 L12.140625,16.3125 C12.421875,16.5625 12.4375,16.828125 12.1875,17.109375 L11.859375,17.4375 C11.578125,17.6875 11.3125,17.6875 11.0625,17.4375 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMore);
export default __webpack_public_path__ + "static/media/icon-more.435dacf1f82c2593abd98233bf5aa14a.svg";
export { ForwardRef as ReactComponent };